import VariantModel from 'coreClasses/product/VariantModel';

import WishlistProductItemModel from './WishlistProductItemModel';

/**
 * Represents WishlistInfoModel
 */
export default class WishlistInfoModel {
	public wishlist_quantity: number;
	public wishlist_value: number;
	public wishlist_products: WishlistProductItemModel[];

	/**
	 * @constructor
	 * @param {object} wishlist
	 * @param {VariantModel[]} products
	 */
	constructor(wishlist: any, products: VariantModel[]) {
		let wishlistTotal = 0;

		const wishlistProducts = wishlist.items.map((productListItem) => {
			const product = products.find((p) => p.getProductId() === productListItem.productId);
			const item = {...new WishlistProductItemModel(productListItem, product)};

			wishlistTotal += item.price || 0;

			return item;
		});

		this.wishlist_quantity = wishlistProducts.length;
		this.wishlist_value = wishlistTotal;
		this.wishlist_products = wishlistProducts;
	}
}